module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts8.33292231.png";